import { styled } from "../../../styled-components";
import { css } from "styled-components";

export const ModalArea = styled.div`
    width: 270px;
    height: 160px;

    border-radius: 14px;

    position: relative;

    background-color: ${p => p.theme.offBaseColor};

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;

    padding: 16px 16px 60px 16px;
`;

export const Title = styled.div`
    ${p => p.theme.fontStyles.AccentHeader4};
    text-align: center;
    letter-spacing: -0.0241176em;

    color: ${p => p.theme.fgColorDark};
`;

export const Description = styled.div`
    color: ${p => p.theme.fgColorDark};
    ${p => p.theme.fontStyles.Body6}
    text-align: center;
`;

export const ButtonWrapper = styled.div`
    display: flex;

    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    height: 44px;

    border-top-color: ${p => p.theme.separatorColor};
    border-top-style: solid;
    border-top-width: 1px;
`;

const buttonProps = css`
    flex-grow: 1;
    min-width: 1px;

    display: flex;
    align-items: center;
    justify-content: center;

    ${p => p.theme.fontStyles.Body4};
    color: ${p => p.theme.fgColorDark};

    :active {
        background-color: ${p => p.theme.picker.activeBgColor};
    }
    :hover {
        background-color: rgba(0, 0, 0, 0.03);
    }

    cursor: pointer;
`;

export const Cancel = styled.div`
    ${buttonProps}

    border-right-color: ${p => p.theme.separatorColor};
    border-right-style: solid;
    border-right-width: 1px;
`;

export const Accept = styled.div<{ isDelete: boolean }>`
    ${buttonProps}

    ${p => (p.isDelete ? `color: ${p.theme.primaryAccentColor};` : "")}
    ${p => p.theme.fontStyles.Header4}
`;

export const Wrapper = styled.div`
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 1000;

    background-color: ${p => p.theme.picker.activeBgColor};

    display: flex;
    justify-content: center;
    align-items: center;

    &.delete ${Accept} {
        color: ${p => p.theme.destroyColor};
    }

    &.quota-warning {
        ${Accept} {
            ${p => p.theme.fontStyles.Body4}
        }

        ${Cancel} {
            ${p => p.theme.fontStyles.Subheader4}
            color: ${p => p.theme.primaryAccentColor};
        }
    }
`;
